<script setup lang="ts">
import CIcon from '@lib/components/CIcon/CIcon.vue'

import { useI18n } from 'vue-i18n'
import useThemeVars from '@lib/composables/useThemeVars'

const { t } = useI18n()
const themeVars = useThemeVars()
</script>

<template>
  <div class="no-item-panel flex flex-col items-center justify-center flex-1 gap-2">
    <CIcon :color="themeVars.primary4" fa-type="far" icon="folder-search" size="36"></CIcon>
    <div class="no-item-panel__description">
      {{ t('canvasUI.browserApp.noItemPanel.description') }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.no-item-panel {
  .no-item-panel__description {
    color: v-bind('themeVars.primary4');
    line-height: 22px;
    letter-spacing: 0.1px;
  }
}
</style>
